<div class="row">
	<div class="col-sm-8 mt-4">
		<h3 data-cy="titulo-pagina">Manter Cargos</h3>
		<p-messages [enableService]="true" [closable]="false"></p-messages>
	</div>
	<div class="col-sm-4 text-right mt-sm-2 mt-4" style="margin-top: 44px !important">
		<a role="button" (click)="prepararCadastrar()" class="br-button primary mt-3 mt-sm-0 ml-sm-3" data-cy="botao-cadastrar-edital">
			Cadastrar cargo
		</a>
	</div>
</div>

<sgp-pesquisar-questionario-cargo
	(filtrosPesquisa)="executarPesquisa($event)"
	(atualizaConcurso)="getConcurso($event)"
	(resultadoPesquisa)="limparResultado()"
>
</sgp-pesquisar-questionario-cargo>

<!-- Exibe o resultado da pesquisa -->
<div *ngIf="resultado">
	<div class="br-table medium mt-4" *ngIf="resultado.items!.length; else semResultado">
		<div class="table-header">
			<div class="top-bar">
				<div class="col-sm-6 table-title" data-cy="titulo-tabela">
					<span *ngIf="resultado.metadata!.total === 1">Foi encontrado 1 resultado</span>
					<span *ngIf="resultado.metadata!.total! > 1">Foram encontrados {{ resultado.metadata!.total }} resultados</span>
				</div>
			</div>
		</div>
		<p-table
			[value]="resultado.items!"
			[lazy]="true"
			(onPage)="paginar($event)"
			(onLazyLoad)="getItensPorPagina($event)"
			[first]="filtro?.first!"
			[totalRecords]="resultado.metadata!.total"
			dataKey="idCargo"
			[(selection)]="registrosSelecionados"
			[rowHover]="true"
			responsiveLayout="stack"
			[autoLayout]="true"
			[paginator]="true"
			[rows]="filtro?.size"
			[rowsPerPageOptions]="[10,20,50,100]"
			sortField="nome"
			data-cy="resultado-pesquisa"
		>
			<ng-template pTemplate="header">
				<tr>
					<!-- <th *ngIf="usuarioGestor" id="checkbox" class="checkbox">
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th> -->
					<th id="cabecalho-cargo-nome">Cargo</th>
					<th id="cabecalho-cargo-codigo">Código do cargo</th>
					<th id="cabecalho-orgao">Órgão</th>
					<th id="cabecalho-orgao">Concurso</th>
					<th id="cabecalho-situacao">Situação do questionário/cargo</th>
					<th id="cabecalho-periodo" *ngIf="concurso?.utiliza_perfil">Período de liberação para respostas</th>
					<th id="cabecalho-acoes" style="width: 10%">Ações</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-rowData>
				<tr>
					<!-- <td *ngIf="usuarioGestor" class="checkbox" width="5%" style="vertical-align: baseline">
						<p-tableCheckbox [value]="rowData" [disabled]="rowData.situacao.codigo!='HOM'"></p-tableCheckbox>
					</td> -->
					<td headers="cabecalho-cargo-nome">{{ rowData.nomeCargo }}</td>
					<td headers="cabecalho-cargo-codigo">{{ rowData.codigoCargo.toString().padStart(6, '0') }}</td>
					<td headers="cabecalho-orgao">{{ rowData.nomeOrgao }}</td>
					<td headers="cabecalho-orgao">{{ rowData.nomeConcurso }}</td>
					<td headers="cabecalho-situacao">{{ rowData.situacao.descricao }}</td>
					<td headers="cabecalho-periodo" *ngIf="concurso?.utiliza_perfil">{{ rowData | dataItensResultadoQuestionario }}</td>
					<td headers="cabecalho-acoes">
						<button
							pButton
							class="br-button circle"
							title="Alterar"
							(click)="prepararAlterar(rowData)"
							[disabled]="rowData.situacao.codigo !== 'RAS'"
							data-cy="botao-alterar-cargo"
							icon="fas fa-edit"
						></button>
						<button
							pButton
							class="br-button circle"
							title="Excluir"
							(click)="excluirItem(rowData)"
							[disabled]="rowData.situacao.codigo !== 'RAS'"
							data-cy="botao-excluir-cargo"
							icon="fas fa-trash-alt"
						></button>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
	<ng-template #semResultado>
		<sgp-nenhum-resultado [exibir]="true" />
	</ng-template>
</div>

<p-confirmDialog acceptLabel="Confirmar" rejectLabel="Cancelar"></p-confirmDialog>

<p-dialog
	id="modalManterTabela"
	[header]="tituloModalManterTabela"
	[(visible)]="exibirModalManterTabela"
	[modal]="true"
	[draggable]="false"
	[closeOnEscape]="true"
	[closable]="true"
	styleClass="modal-70vw"
	[breakpoints]="{'960px': '50vw', '640px': '100vw'}"
	[contentStyle]="{minHeight: '500px', 'overflow-y': 'scroll', overflowX: 'hidden', marginBottom: '0px'}"
	[baseZIndex]="10000"
	[resizable]="false"
	data-cy="modalManterTabela"
	*ngIf="exibirModalManterTabela"
>
	<p-messages [(value)]="mensagensErro" [closable]="false"></p-messages>
	<sgp-manter-questionario-cargo
		[item]="itemTabela!"
		(itemSalvo)="salvarItem($event)"
		(fecharModal)="exibirModalManterTabela=false"
	></sgp-manter-questionario-cargo>
</p-dialog>
